export default __webpack_public_path__ + "static/video-banner-bf72f53aebaa2f41e96fc1ea55d5ad2d.webm";